import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './account-details.scss';
import { DashboardHeader } from '../../../atoms';
import { ManageBusinessAccounts, BusinessAccountDetails } from '../../molecules';
import { DashContentFooter } from '../../../molecules';
import { DashboardContext } from '../../../../context';

function AccountDetails() {
  const history = useHistory();
  const [dashData, setDashData] = useState({});

  useEffect(() => {}, []);

  const handleBackClick = () => {
    history.push('/manage-accounts');
  };

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className="row no-gutters">
        <div className="no-gutters dash-left-wrapper">
          <DashboardHeader />
          <BusinessAccountDetails handleBackClick={() => handleBackClick()}/>
          <DashContentFooter />
        </div>
      </div>
    </DashboardContext.Provider>
  );
}

export default AccountDetails;
